import { render, staticRenderFns } from "./Basic_content.vue?vue&type=template&id=b8a03bfe&style=height%3A100%25"
import script from "./Basic_content.vue?vue&type=script&lang=js"
export * from "./Basic_content.vue?vue&type=script&lang=js"
import style0 from "./Basic_content.vue?vue&type=style&index=0&id=b8a03bfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports